module.exports = __webpack_public_path__ + "img/5560e3c.jpg";